exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.thank-you-message {\n    text-align: center;\n}\n.subscribe-section {\n  text-align: center;\n  padding-top: 20px;\n}\n.subscribe-button {\n  text-decoration: none;\n}\n", ""]);

// exports
